export default {"src":"/_next/static/media/WRBY.139dfa11.svg","height":18,"width":18};